// Menu pathnames
const REGISTRATION = "registration";
const REPORT = "report";
// Pages pathnames
const HOME = "";
const DOCUMENTATION = "documentation";
const EMPLOYEE = "employee";
const EMPLOYER = "employer";
const LOGIN = "login";
const FORGOT_PASSWORD = "forgotPassword";
const RESET_PASSWORD = "reset-password/:data";
const AUTO_LOGIN = "login/:data";
const REGISTRATION_FORM = "registration-form";
const USER = "user";
const DOCUMENT = "document";
const SETTINGS = "settings";
const FINANCE = "finance";
const PLANS = "plans";
const ADMISSION_FLOW = "admission-flow";
const NEWS = "news";
// CRUD pathnames
const CREATE = "create";
const EDIT = "edit";
// Publics
const SENDING_DOCUMENTS = "sending-documents"; // Old
const NEW_SENDING_DOCUMENTS = "new-sending-documents";
const DOWNLOAD_CONTRACT = "download-contract";
const WORK_PROPOSAL = "work-proposal";
const ADMISSION_EXAM = "admission-exam";
const RESPONSIBILITY_TERM = "responsibility-term";

export const Routes = {
  DOCUMENTATION: `/${REGISTRATION}/${DOCUMENTATION}`,
  DOCUMENTATION_CREATE: `/${REGISTRATION}/${DOCUMENTATION}/${CREATE}`,
  DOCUMENTATION_EDIT: `/${REGISTRATION}/${DOCUMENTATION}/${EDIT}`,
  EMPLOYEE: `/${REGISTRATION}/${EMPLOYEE}`,
  EMPLOYEE_CREATE: `/${REGISTRATION}/${EMPLOYEE}/${CREATE}`,
  EMPLOYEE_EDIT: `/${REGISTRATION}/${EMPLOYEE}/${EDIT}`,
  EMPLOYER: `/${REGISTRATION}/${EMPLOYER}`,
  EMPLOYER_CREATE: `/${REGISTRATION}/${EMPLOYER}/${CREATE}`,
  EMPLOYER_EDIT: `/${REGISTRATION}/${EMPLOYER}/${EDIT}`,
  HOME: `/${HOME}`,
  LOGIN: `/${LOGIN}`,
  FORGOT_PASSWORD: `/${FORGOT_PASSWORD}`,
  RESET_PASSWORD: `${RESET_PASSWORD}`,
  AUTO_LOGIN: `/${AUTO_LOGIN}`,
  REGISTRATION: `/${REGISTRATION}`,
  REPORT: `/${REPORT}`,
  REPORT_REGISTRATION_FORM: `/${REPORT}/${REGISTRATION_FORM}`,
  USER: `/${REGISTRATION}/${USER}`,
  USER_CREATE: `/${REGISTRATION}/${USER}/${CREATE}`,
  USER_EDIT: `/${REGISTRATION}/${USER}/${EDIT}`,
  DOCUMENT: `/${REGISTRATION}/${DOCUMENT}`,
  DOCUMENT_CREATE: `/${REGISTRATION}/${DOCUMENT}/${CREATE}`,
  DOCUMENT_EDIT: `/${REGISTRATION}/${DOCUMENT}/${EDIT}`,
  SENDING_DOCUMENTS: `/${SENDING_DOCUMENTS}`,
  NEW_SENDING_DOCUMENTS: `/${NEW_SENDING_DOCUMENTS}/:data`,
  DOWNLOAD_CONTRACT: `${DOWNLOAD_CONTRACT}/:data`,
  WORK_PROPOSAL: `${WORK_PROPOSAL}/:data`,
  ADMISSION_EXAM: `${ADMISSION_EXAM}/:data`,
  RESPONSIBILITY_TERM: `${RESPONSIBILITY_TERM}/:data`,
  SETTINGS: `/${SETTINGS}`,
  FINANCE: `/${FINANCE}`,
  FINANCE_PLANS: `/${FINANCE}/${PLANS}`,
  ADMISSION_FLOW: `/${REGISTRATION}/${ADMISSION_FLOW}`,
  ADMISSION_FLOW_CREATE: `/${REGISTRATION}/${ADMISSION_FLOW}/${CREATE}`,
  ADMISSION_FLOW_EDIT: `/${REGISTRATION}/${ADMISSION_FLOW}/${EDIT}`,
  NEWS: `/${NEWS}`,
};

export const Keys = {
  HOME,
  REGISTRATION,
  REPORT,
  FINANCE,
};
